// define here every ACTION and MUTATOR, so we can use const instead of string
///////////////////////////// ************************ACTIONS*********************/////////////////////////////
export enum ACTIONS {
  SIGN_UP_USER = "SIGN_UP_USER",
  SIGN_IN_USER = "SIGN_IN_USER",
  SIGN_OUT_USER = "SIGN_OUT_USER",
  SIGN_IN_USER_WITH_GOOGLE = "SIGN_IN_USER_WITH_GOOGLE",
  SIGN_IN_USER_WITH_FACEBOOK = "SIGN_IN_USER_WITH_FACEBOOK",
}
///////////////////////////// ************************MUTATIONS*********************////////////////////////////
export enum MUTATIONS {
  SET_LOCALE = "SET_LOCALE",
  SET_IS_SIGN_UP_VISIBLE = "SET_IS_SIGN_UP_VISIBLE",
  SET_CURRENT_USER = "SET_CURRENT_USER",
  ADD_ALERT = "ADD_ALERT",
  CLEAR_ALERT = "CLEAR_ALERT",
  SET_UI_BLOCK = "SET_UI_BLOCK",
  SET_IS_PAGE_LOADED = "SET_IS_PAGE_LOADED",
  SET_USERPROFILE = "SET_USERPROFILE",
}
